import { createRouter, createWebHashHistory } from "vue-router";

import Home from "./views/home-page";
import Profile from "./views/profile-page";
import Tasks from "./views/tasks-page";
import defaultLayout from "./layouts/my-layout.vue";
// import defaultLayout from "./layouts/side-nav-outer-toolbar";
import simpleLayout from "./layouts/single-card";
import cetakLayout from "./layouts/cetak-layout";
import EmptyLayout from "./layouts/empty-layout.vue";
import docsLayout from "./layouts/docs-layout.vue";
import { useAppStore } from "./stores/app-store";

function loadView(view) {
  return () => import(/* webpackChunkName: "login" */ `./views/${view}.vue`)
}

function loadPage(view) {
  return () => import(`./views/${view}.vue`)
}

function loadPageCustom(path) {
  return ()=>import(`./components/ui/${path}`)
}

function loadCetakPage(key) {
  return () => import(`./cetak/${key}-cetak.vue`)
}

function loadEditPage(key) {
  return () => import(`./views/${key}_edit-page.vue`)
}

function loadBaruPage(key) {
  return () => import(`./views/${key}_baru-page.vue`)
}

function createCetakRoute(key) {
  let path = `/${key}_cetak/:id`
  let name = key + '_cetak'
  let layout = cetakLayout
  return {
    path,
    name,
    meta: {
      requiresAuth: true,
      layout,
      name,
      akses: key + ':cetak'
    },
    component: loadCetakPage(key)
  }
}

function createEditRoute(key) {
  let path = `/${key}_edit/:id`
  let name = key + '_edit'
  let layout = defaultLayout
  return {
    path,
    name,
    meta: {
      requiresAuth: true,
      layout,
      name,
      akses: key + ':update'
    },
    component: loadEditPage(key)
  }
}

function createBaruRoute(key) {
  let path = `/${key}_baru`
  let name = key + '_baru'
  let layout = defaultLayout
  return {
    path,
    name,
    meta: {
      requiresAuth: true,
      layout,
      name,
      akses: key + ':baru'
    },
    component: loadBaruPage(key)
  }
}

function createRouteEntry(name, path, key, component, layout = defaultLayout) {
  return {
    path,
    name,
    meta: {
      requiresAuth: true,
      layout,
      key,
      akses: key + ':lihat'
    },
    component
  }
}

function createRoute(name, path = null, key = null, layout = defaultLayout) {
  if (!path) {
    path = `/${name}`;
  }
  if (!key) {
    key = name;
  }
  return createRouteEntry(name, path, key, loadPage(name + "-page"), layout);
}


const router = new createRouter({
  routes: [
    {
      path: "/home",
      name: "home",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: Home
    },
    // master
    createRoute('pengguna', '/pengguna', 'pengguna'),
    createRoute('jabatan', '/jabatan', 'jabatan'),
    createRoute('setting-poin', '/setting/poin', 'setting_poin'),
    createRoute('setting-akun', '/setting/akun', 'setting_akun'),
    createRoute('setting-no-dokumen', '/setting/no_dokumen', 'setting_no_dokumen'),
    createRoute('setting-aplikasi', '/setting/aplikasi', 'setting_aplikasi'),
    createRoute('setting-android', '/setting/android', 'setting_android'),
    createRoute('setting_stiker'),
    createRoute('local_setting'),
    createRoute('giro', '/giro', 'giro'),
    createRoute('barang'),
    createRoute('daftar_foto_barang'),
    createRoute('brand', '/brand', 'brand'),
    createRoute('gudang', '/gudang', 'gudang'),
    createRoute('departemen', '/departemen', 'departemen'),
    createRoute('kategori-barang', '/kategori_barang', 'kategori_barang'),
    createRoute('kategori-property', '/kategori_property', 'kategori_property'),
    createRoute('jenis_harga_jual', '/jenis_harga_jual', 'jenis_harga_jual'),
    createRoute('komponen_daily_report', '/komponen_daily_report', 'komponen_daily_report'),
    createRoute('tarif-billing', '/tarif_billing', 'tarif_billing'),
    createRoute('kategori_akun'),
    createRoute('kategori_akun_2'),
    createRoute('sales', '/sales', 'sales'),
    createRoute('area-sales', '/area_sales', 'area_sales'),
    createRoute('ekspedisi', '/ekspedisi', 'ekspedisi'),
    createRoute('edc', '/edc', 'edc'),
    createRoute('kartu_bank', '/kartu_bank', 'kartu_bank'),
    createRoute('bank', '/bank', 'bank'),
    createRoute('supplier', '/supplier', 'supplier'),
    createRoute('vendor', '/vendor', 'vendor'),
    createRoute('pelanggan', '/pelanggan', 'pelanggan'),
    createRoute('finance'),
    createRoute('kategori_pelanggan', '/kategori_pelanggan', 'kategori_pelanggan'),
    createRoute('kategori_diskon'),
    createRoute('kategori_komisi'),
    createRoute('akun', '/akun', 'akun'),
    createRoute('karyawan', '/karyawan', 'karyawan'),
    createRoute('petugas', '/petugas', 'petugas'),
    createRoute('property', '/property', 'property'),
    createRoute('lokasi', '/lokasi', 'lokasi'),
    createRoute('addon', '/addon', 'addon'),
    createRoute('ongkir', '/ongkir', 'ongkir'),
    createRoute('tanda'),
    createRoute('file_foto'),
    createRoute('shift'),

    // jmm
    createRouteEntry('jmm_membership', '/jmm_membership', 'jmm_membership', loadPageCustom('jmm/membership/jmm-membership-page.vue')),
    createRouteEntry('jmm_registrasi', '/jmm_registrasi', 'jmm_registrasi', loadPageCustom('jmm/registrasi/jmm-registrasi-page.vue')),
    createRouteEntry('jmm_jual', '/jmm_jual', 'jmm_jual', loadPageCustom('jmm/jual/jmm-jual-page.vue')),

    // gaji
    createRoute('komponen_gaji', '/komponen_gaji', 'komponen_gaji'),
    createRoute('slip_gaji', '/slip_gaji', 'slip_gaji'),
    createRoute('slip_gaji_cetak', '/slip_gaji_cetak/:id', 'slip_gaji_cetak', cetakLayout),

    // poin
    createRoute('poin', '/poin', 'poin'),
    createRoute('poin_pakai', '/poin_pakai', 'poin_pakai'),

    // transaksi
    createRoute('purchase-order', '/purchase_order', 'purchase_order'),
    createBaruRoute('purchase_order'),
    createEditRoute('purchase_order'),
    createRoute('terima-barang', '/terima_barang', 'terima_barang'),
    createRoute('beli', '/beli', 'beli'),
    createBaruRoute('beli'),
    createEditRoute('beli'),
    createRoute('sales-order', '/sales_order', 'sales_order'),
    createRoute('jual', '/jual', 'jual'),
    createRoute('jual_proforma', '/jual_proforma', 'jual_proforma'),
    createRoute('delivery-order', '/delivery_order', 'delivery_order'),
    createRoute('delivery-order-cetak', '/delivery_order/:id', 'delivery_order', cetakLayout),
    createRoute('pakai-barang', '/pakai_barang', 'pakai_barang'),
    createRoute('pakai-barang-cetak', '/pakai_barang/:id', 'pakai_barang', cetakLayout),
    createRoute('titip-barang', '/titip_barang', 'titip_barang'),
    createRoute('mutasi-ag', '/mutasi_ag', 'mutasi_ag'),
    createRoute('mutasi-ag-cetak', '/mutasi_ag/:id', 'mutasi_ag', cetakLayout),
    createRoute('konversi-barang', '/konversi_barang', 'konversi_barang'),
    createRoute('stok-opname', '/stok_opname', 'stok_opname'),
    createRoute('stok_opname_simple', '/stok_opname_simple', 'stok_opname_simple'),
    createRoute('stok-opname-tugas', '/stok_opname_tugas', 'stok_opname_tugas'),
    createRoute('wa-nota', '/wa_nota', 'wa_nota'),
    createRoute('perangkat-cetak', '/perangkat_cetak', 'perangkat_cetak'),
    createRoute('stok-opname-tugas-review', '/stok_opname_tugas/:id', 'stok_opname_tugas'),

    // finance
    createRoute('piutang', '/piutang', 'piutang'),
    createRoute('hutang', '/hutang', 'hutang'),
    createRoute('hutang_biaya', '/hutang_biaya', 'hutang_biaya'),
    createRoute('bkk', '/bkk', 'bkk'),
    createRoute('bkm', '/bkm', 'bkm'),
    createRoute('bayar-hutang', '/bayar_hutang', 'bayar_hutang'),
    createRoute('bayar-piutang', '/bayar_piutang', 'bayar_piutang'),
    createRoute('bayar_hutang_biaya'),
    createRoute('mutasi_bank'),
    createRoute('rep_mutasi_bank'),
    createRoute('saldo_kas'),

    createRoute('fix-hpp', '/fix_hpp', 'hitung_hpp'),
    createRoute('fix_hpp_task', '/fix_hpp_task', 'fix_hpp_task'),
    createRoute('hpp_adjustment', '/hpp_adjustment', 'hpp_adjustment'),
    createRoute('tarif-pajak', '/tarif_pajak', 'tarif_pajak'),
    createRoute('kartu_stok', '/rep/kartu_stok', 'kartu_stok'),
    createRoute('ledger', '/rep/ledger', 'rep_ledger'),
    createRoute('update_terkirim_jual'),

    // cetak
    createCetakRoute("jual"),
    createCetakRoute('stok_opname'),
    createCetakRoute("purchase_order"),
    createCetakRoute('sales_order'),
    createCetakRoute('beli'),
    createCetakRoute('delivery_order'),
    createCetakRoute('terima_barang'),
    createCetakRoute('biaya'),
    createCetakRoute('bkk'),
    createCetakRoute('bkm'),
    createCetakRoute("hutang"),
    createCetakRoute("piutang"),
    createCetakRoute("jurnal"),
    createCetakRoute("pindah_kas"),
    createCetakRoute("rekon_bank"),
    createCetakRoute("bayar_komisi_guide"),

    // laporan
    createRoute('hutang_karyawan', '/hutang_karyawan', 'hutang_karyawan'),
    createRoute('bayar_hutang_karyawan', '/bayar_hutang_karyawan', 'bayar_hutang_karyawan'),
    createRoute('jurnal', '/jurnal', 'jurnal'),
    createRoute('rekap-pelanggan', '/rekap_pelanggan', 'rekap_pelanggan'),
    createRoute('kartu_piutang', '/rep/kartu_piutang', 'kartu_piutang'),
    createRoute('kartu_hutang', '/rep/kartu_hutang', 'kartu_hutang'),
    createRoute('kartu_hutang_karyawan', '/rep/kartu_hutang_karyawan', 'rep_kartu_hutang_karyawan'),
    createRoute('laba_kotor', '/rep/laba_kotor', 'rep_laba_kotor'),
    createRoute('laba_kotor_lunas', '/rep/laba_kotor_lunas', 'rep_laba_kotor_lunas'),
    createRoute('rep_purchase_order', '/rep/purchase_order', 'rep_purchase_order'),
    createRoute('rep-jual', '/rep/jual', 'rep_jual'),
    createRoute('rep-jual-proforma', '/rep/jual_proforma', 'rep_jual_proforma'),
    createRoute('rep-beli', '/rep/beli', 'rep_beli'),
    createRoute('rep-terima-barang', '/rep/terima_barang', 'rep_terima_barang'),
    createRoute('rep-delivery-order', '/rep/delivery_order', 'rep_delivery_order'),
    // UAT #1752: hak akses ikut Laporan Delivery Order
    createRoute('rep-rekap-delivery-order', '/rep/rekap_delivery_order', 'rep_delivery_order'),
    createRouteEntry('rekap-delivery-order-cetak', '/rekap_delivery_order_cetak/:id', 'rep_delivery_order', loadCetakPage('rekap_delivery_order'), cetakLayout),
    createRoute('rep-daftar-jurnal', '/rep/daftar_jurnal', 'rep_daftar_jurnal'),
    createRoute('kelompok-aset', '/kelompok_aset', 'kelompok_aset'),
    createRoute('aset', '/aset', 'aset'),
    createRoute('penyusutan', '/penyusutan', 'penyusutan'),
    createRoute('rep-pakai-barang', '/rep/pakai_barang', 'rep_pakai_barang'),
    createRoute('rep-mutasi-ag', '/rep/mutasi_ag', 'rep_mutasi_ag'),
    createRoute('rep-titip-barang', '/rep/titip_barang', 'rep_titip_barang'),
    createRoute('pricelist', '/pricelist', 'pricelist'),
    createRoute('rep-daftar-hpp', '/rep/daftar_hpp', 'rep_daftar_hpp'),
    createRoute('rep-kartu-stok-hpp', '/rep/kartu_stok_hpp', 'rep_kartu_stok_hpp'),
    createRoute('rep-stok', '/rep/stok', 'rep_stok'),
    createRoute('rep_stok_sn', '/rep/stok_sn', 'rep_stok_sn'),
    createRoute('rep-stok-realtime', '/rep/stok_realtime', 'rep_stok_realtime'),
    createRoute('rep-rekap-jual', '/rep/rekap_jual', 'rep_rekap_jual'),
    createRoute('rep-rekap-kasir', '/rep/rekap_kasir', 'rep_rekap_kasir'),
    createRoute('rep-rekap-gudang', '/rep/rekap_gudang', 'rep_rekap_gudang'),
    createRoute('rep-rekap-jual-barang', '/rep/rekap_jual_barang', 'rep_rekap_jual_barang'),
    createRoute('rep-rekap-jual-proforma', '/rep/rekap_jual_proforma', 'rep_rekap_jual_proforma'),
    createRoute('rep-rekap-piutang', '/rep/rekap_piutang', 'rep_rekap_piutang'),
    createRoute('rep_piutang_departemen', '/rep/piutang_departemen', 'rep_rekap_piutang'),
    createRoute('rep-rekap-hutang', '/rep/rekap_hutang', 'rep_rekap_hutang'),
    createRoute('rep_kegiatan', '/rep/kegiatan', 'rep_kegiatan'),
    createRoute('rep_aktivitas', '/rep/aktivitas', 'rep_aktivitas'),
    createRoute('rep_jual_faktur', '/rep/jual_faktur', 'rep_jual_faktur'),
    // Key = the access item rep_stok_with_jual (Logic.php 735); 'rep_stok_jual' was granted to nobody (UAT #1359).
    createRoute('rep_stok_jual', '/rep/stok_jual', 'rep_stok_with_jual'),
    createRoute('rep_barang_fast_moving', '/rep/barang_fast_moving', 'rep_barang_fast_moving'),
    createRoute('rep_rekap_stok', '/rep/rekap_stok', 'rep_rekap_stok'),
    createRoute('rep_biaya', '/rep/biaya', 'rep_biaya'),
    createRoute('rep_jmm_komisi_petugas', '/rep/jmm_komisi_petugas', 'rep_jmm_komisi_petugas'),
    createRoute('rep_jmm_registrasi', '/rep/jmm_registrasi', 'rep_jmm_registrasi'),
    createRoute('rep_jmm_kartu_membership', '/rep/jmm_kartu_membership', 'rep_jmm_kartu_membership'),
    createRoute('rep_jmm_kunjungan_member', '/rep/jmm_kunjungan_member', 'rep_jmm_kunjungan_member'),


    createRoute('biaya', '/biaya', 'biaya'),
    createRoute('titip-transfer', '/titip_transfer', 'titip_transfer'),
    createRoute('tarik-tunai', '/tarik_tunai', 'tarik_tunai'),
    createRoute('neraca-saldo', '/rep/neraca_saldo', 'neraca_saldo'),
    createRoute('neraca', '/rep/neraca', 'neraca'),
    createRoute('laba_bersih', '/rep/laba_bersih', 'laba_bersih'),
    createRoute('servis', '/servis', 'servis'),
    createRoute('rep_titip_transfer_tarik_tunai', '/rep/titip_transfer_tarif_tunai', 'rep_titip_transfer_tarik_tunai'),
    createRoute('pindah_kas', '/pindah_kas', 'pindah_kas'),
    createRoute('rekon_bank', '/rekon_bank', 'rekon_bank'),
    createRoute('servis_bayar', '/servis_bayar', 'servis_bayar'),
    createRoute('rep_bayar_piutang', '/rep/bayar_piutang', 'rep_bayar_piutang'),
    createRoute('rep_bayar_hutang', '/rep/bayar_hutang', 'rep_bayar_hutang'),
    createRoute('rep_bayar_jual', '/rep/bayar_jual', 'rep_bayar_jual'),
    createRoute('rep_teknisi_spk', '/rep/teknisi_spk', 'rep_teknisi_spk'),
    createRoute('promo', '/promo', 'promo'),

    // absensi
    createRoute('import_absen_easylink', '/import_absen_easylink', 'import_absen_easylink'),
    createRoute("easylink_user"),
    createRoute("absen"),
    createRoute("rekap_absen"),
    createRoute("alat_fingerprint"),
    createRoute("gaji"),
    createRoute("setting_gaji"),
    createCetakRoute("gaji"),

    // sistem setting
    createRoute("setting_sistem"),

    // peralatan
    createRoute('fix_data', '/fix_data', 'fix_data'),
    createRoute('schedule', '/schedule', 'schedule'),
    createRoute('trusted_device', '/trusted_device', 'trusted_device'),
    createRoute('import_barang', '/import_barang', 'import_barang'),
    createRoute('import_pricelist', '/import_pricelist', 'import_pricelist'),
    createRoute('import_beli', '/import_beli', 'import_beli'),
    createRoute('import_pelanggan', '/import_pelanggan', 'import_pelanggan'),
    createRoute('import_supplier', '/import_supplier', 'import_supplier'),
    createRoute('import_harga_jual', '/import_harga_jual', 'import_harga_jual'),
    createRoute('import_barang_satuan'),
    createRoute('template_report_desktop'),
    createRoute('daftar_shortcut'),
    createRoute('logging'),
    createRoute('audit_log'),

    // antrian
    createRoute('antrian', '/antrian', 'antrian'),
    createRoute('antrian_checkin', '/antrian_checkin', 'antrian_checkin'),
    createRoute('antrian_proses', '/antrian_proses', 'antrian_proses'),
    createRoute('antrian_selesai', '/antrian_selesai', 'antrian_selesai'),
    createRoute('antrian_display', '/antrian_display', 'antrian_display'),
    createRoute('antrian_display_view', '/antrian_display_view', 'antrian_display_view', EmptyLayout),
    createRoute('entri_antrian_baru', '/entri_antrian_baru', 'entri_antrian_baru'),
    createRoute('entri_antrian_baru_view', '/entri_antrian_baru_view', 'entri_antrian_baru_view', EmptyLayout),
    createRoute('entri_antrian_checkin'),
    createRoute('entri_antrian_proses'),
    createRoute('entri_antrian_selesai'),

    // stiker
    createRoute('travel_guide'),
    createRoute('travel_agent'),
    createRoute('stiker'),
    createRoute('entri_stiker'),
    createRoute('rep_kunjungan_stiker'),
    createRoute('stiker_selesai'),
    createRoute('rep_potongan_jual'),
    createRoute('rep_rekap_kunjungan'),
    createRoute('query_stiker'),
    createRoute('bayar_komisi_guide'),
    createRoute('tukar_poin_guide'),
    createRoute('kartu_poin_guide'),
    createRoute('kartu_komisi_guide'),

    // other
    createRoute('garansi', '/garansi', 'garansi'),
    createRoute('resep', '/resep', 'resep'),
    createRoute('daily_report', '/daily_report', 'daily_report'),
    createCetakRoute('daily_report'),

    // negara
    createRoute('lawan_transaksi', '/lawan_transaksi', 'lawan_transaksi'),
    createRoute('barang_efaktur', '/barang_efaktur', 'barang_efaktur'),
    createRoute('faktur_masukan', '/faktur_masukan', 'faktur_masukan'),
    createRoute('faktur_keluaran', '/faktur_keluaran', 'faktur_keluaran'),

    // dashboard
    createRoute('dashboard_1'),

    // spk
    createRoute('spk', '/spk', 'spk'),
    createRoute('survey', '/survey', 'survey'),
    createRoute('rab', '/rab', 'rab'),
    createRoute('penawaran', '/penawaran', 'penawaran'),
    createRoute('surat_pesanan', '/surat_pesanan', 'surat_pesanan'),
    createRoute('spk_barang', '/spk_barang', 'spk_barang'),
    createRoute('spk_biaya', '/spk_biaya', 'spk_biaya'),
    createRoute('bayar_spk_biaya', '/bayar_spk_biaya', 'bayar_spk_biaya'),
    createRoute('pengerjaan', '/pengerjaan', 'pengerjaan'),
    createRoute('serah_terima', '/serah_terima', 'serah_terima'),
    createRoute('invoice_spk', '/invoice_spk', 'invoice_spk'),
    createRoute('bayar_spk', '/bayar_spk', 'bayar_spk'),
    createRoute('rep_aktivitas_spk', '/rep/aktivitas_spk', 'rep_aktivitas_spk'),
    createRoute('spk_selesai', '/spk_selesai', 'spk_selesai'),
    createRoute('rep_barang_biaya_spk', '/rep_barang_biaya_spk', 'rep_barang_biaya_spk'),

    // project
    createRoute('jms_setting'),
    createRoute('jms_jenis_dokumen'),
    createRoute('jms_jenis_gambar'),
    createRoute('jms_project'),
    createRoute('jms_penawaran'),
    createRoute('jms_sales_order'),
    createRoute('jms_minta_material'),
    createRoute('jms_surat_jalan'),
    createRoute('jms_surat_tugas'),
    createRoute('jms_spk'),
    createRoute('jms_komisi'),
    createRoute('jms_berita_acara_progress'),
    createRoute('jms_berita_acara_serah_terima'),
    createRoute('jms_rab'),
    createRoute('jms_rab_final'),
    createRoute('jms_gambar'),
    createRoute('jms_invoice'),
    createRoute('jms_bayar'),
    createRoute('jms_faktur_pajak'),
    createRoute('jms_po_customer'),
    createCetakRoute('jms_project'),
    createCetakRoute('jms_penawaran'),
    createCetakRoute('jms_sales_order'),
    createCetakRoute('jms_minta_material'),
    createCetakRoute('jms_surat_jalan'),
    createCetakRoute('jms_surat_tugas'),
    createCetakRoute('jms_spk'),
    createCetakRoute('jms_komisi'),
    createCetakRoute('jms_berita_acara_progress'),
    createCetakRoute('jms_berita_acara_serah_terima'),
    createCetakRoute('jms_gambar'),
    createCetakRoute('jms_invoice'),
    createCetakRoute('jms_rab'),
    createCetakRoute('jms_rab_final'),

    // catalog
    createRoute('cat_top_banner'),
    createRoute('cat_middle_banner'),
    createRoute('cat_bottom_banner'),
    createRoute('cat_footer'),
    createRoute('cat_slogan'),
    createRoute('cat_toko'),
    createRoute('cat_cabang'),
    createRoute('cat_upload_foto_barang'),
    createRoute('cat_setting'),

    {
      path: "/profile",
      name: "profile",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: Profile
    },
    {
      path: "/tasks",
      name: "tasks",
      meta: {
        requiresAuth: true,
        layout: defaultLayout
      },
      component: Tasks
    },
    {
      path: "/login-form",
      name: "login-form",
      meta: {
        requiresAuth: false,
        layout: simpleLayout,
        title: "Masuk",
        description: "Masuk dengan akun pengguna toko Anda."
      },
      component: loadView("login-form")
    },
    {
      path: "/reset-password",
      name: "reset-password",
      meta: {
        requiresAuth: false,
        layout: simpleLayout,
        title: "Reset Password",
        description: "Please enter the email address that you used to register, and we will send you a link to reset your password via Email."
      },
      component: loadView("reset-password-form")
    },
    {
      path: "/create-account",
      name: "create-account",
      meta: {
        requiresAuth: false,
        layout: simpleLayout,
        title: "Sign Up"
      },
      component: loadView("create-account-form"),
    },
    {
      path: "/change-password/:recoveryCode",
      name: "change-password",
      meta: {
        requiresAuth: false,
        layout: simpleLayout,
        title: "Change Password"
      },
      component: loadView("change-password-form")
    },
    // Panduan Pengguna: publik (tanpa login), layout sendiri, dibuka di tab baru dari tombol
    // Panduan di bilah atas. Daftar isinya di src/docs/docs-nav.js.
    {
      path: "/panduan",
      name: "panduan",
      meta: { requiresAuth: false, layout: docsLayout },
      component: loadPage("panduan-page")
    },
    {
      path: "/panduan/billiard-harga-menu",
      name: "panduan-billiard-harga-menu",
      meta: { requiresAuth: false, layout: docsLayout },
      component: loadPage("panduan-billiard-harga-menu-page")
    },
    {
      path: "/panduan/hpp-otomatis",
      name: "panduan-hpp-otomatis",
      meta: { requiresAuth: false, layout: docsLayout },
      component: loadPage("panduan-hpp-otomatis-page")
    },
    {
      path: "/panduan/masa-langganan",
      name: "panduan-masa-langganan",
      meta: { requiresAuth: false, layout: docsLayout },
      component: loadPage("panduan-masa-langganan-page")
    },
    {
      path: "/",
      redirect: "/home"
    },
    {
      path: "/recovery",
      redirect: "/home"
    },
    {
      path: "/:pathMatch(.*)*",
      redirect: "/home"
    }
  ],
  history: createWebHashHistory()
});

router.beforeEach((to, from, next) => {
  const store = useAppStore();
  if (to.name === "login-form" && store.isLogin) {
    return next({ name: "home" });
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    const store = useAppStore();
    if (!store.isLogin) {
      next({
        name: "login-form",
        query: { redirect: to.fullPath }
      });
    } else {
      if (to.fullPath == '/home') {
        return next()
      }
      // Tugas Opname is behind a per-tenant flag: off (status read) = no route. Not read yet (null):
      // let it through, the API itself refuses with FITUR_NONAKTIF and the page shows that message.
      if (to.meta.key === 'stok_opname_tugas' && store.fitur.tugas_opname === false) {
        return next({ name: "home" });
      }
      if (to.meta.key === 'wa_nota' && store.fitur.wa_nota === false) {
        return next({ name: "home" });
      }
      if (to.meta.key === 'perangkat_cetak' && store.fitur.perangkat_cetak === false) {
        return next({ name: "home" });
      }
      if (to.meta.akses) {
        if (store.boleh(to.meta.akses)) {
          next()
        } else {
          next({
            name: "login-form",
          });
        }
      } else {
        next()
      }
    }
  } else {
    next();
  }
});

export default router;
